export default async ({ commit, rootGetters }) => {
    let checkMusic = await rootGetters['music/music']

    if(checkMusic) {
        let priceMusic = await rootGetters['settings/priceMusic']

        commit('setPriceMusic', {
            value: priceMusic,
            coef: priceMusic
        })
    } else {
        commit('setPriceMusic', {
            value: 1,
            coef: 1
        })
    }
}